import React from 'react';

// i18n initialization
import 'utils/locales/i18n';

// ==============================|| LOCALIZATION ||============================== //

interface LocalsProps {
  children: React.ReactNode;
}

export default function Locales({ children }: LocalsProps) {
  return <>{children}</>;
}
